import styles from './allChallenges.module.css';

export type AllChallengesTab = 'active' | 'completed';

type ChallengeTabsProps = {
  activeTab: AllChallengesTab;
  onTabChange: (tab: AllChallengesTab) => void;
};

const TABS: { id: AllChallengesTab; label: string }[] = [
  { id: 'active', label: 'Active' },
  { id: 'completed', label: 'Completed' },
];

export default function ChallengeTabs({ activeTab, onTabChange }: ChallengeTabsProps) {
  return (
    <div className={styles.tabs}>
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`${styles.tab} ${activeTab === tab.id ? styles.tabActive : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
